import { ACTIONS } from '../actions';

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: null,
  availableOptionLabels: [],
  paginator: null,
  products: [],
  createdOrder: null,
  paymentLink: null,
  createOrderLoading: false,
  createOrderError: null,
  // order-by-session
  sessionOrder: null,
  sessionOrderLoading: false,
  sessionOrderError: null,
};

export const order = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.GET_ORDER_PRODUCTS_BY_COLLECTIONS_START:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case ACTIONS.GET_ORDER_PRODUCTS_BY_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        availableOptionLabels: action.payload.availableOptionLabels,
        paginator: action.payload.paginator,
        products: action.payload.results,
      };
    case ACTIONS.GET_ORDER_PRODUCTS_BY_COLLECTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case ACTIONS.CREATE_ORDER_START:
      return {
        ...state,
        createOrderLoading: true,
        createOrderError: null,
        createdOrder: null,
        paymentLink: null,
      };
    case ACTIONS.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        createOrderLoading: false,
        createdOrder: action.payload.order,
        paymentLink: action.payload.paymentLink,
      };
    case ACTIONS.CREATE_ORDER_FAILURE:
      return {
        ...state,
        createOrderLoading: false,
        createOrderError: action.payload,
      };
    case ACTIONS.GET_ORDER_BY_SESSION_START:
      return {
        ...state,
        sessionOrderLoading: true,
        sessionOrderError: null,
        sessionOrder: null,
      };
    case ACTIONS.GET_ORDER_BY_SESSION_SUCCESS:
      return {
        ...state,
        sessionOrderLoading: false,
        sessionOrder: action.payload,
      };
    case ACTIONS.GET_ORDER_BY_SESSION_FAILURE:
      return {
        ...state,
        sessionOrderLoading: false,
        sessionOrderError: action.payload,
      };
    default:
      return state;
  }
};
